import React, { useState } from 'react';
import { X } from 'lucide-react';
function LegalModal({
  title,
  content,
  onClose
}: {
  title: string;
  content: React.ReactNode;
  onClose: () => void;
}) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-41">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-42" />
      <div className="relative bg-slate-900 border border-slate-700 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-43">
        <div className="sticky top-0 bg-slate-900 border-b border-slate-700 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-44">
          <h3 className="text-xl font-oswald font-bold text-white uppercase tracking-wide" data-id="element-45">
            {title}
          </h3>
          <button onClick={onClose} className="text-slate-400 hover:text-white transition-colors p-1" data-id="element-46">
            <X className="w-6 h-6" data-id="element-47" />
          </button>
        </div>
        <div className="px-6 py-6 text-slate-300 text-sm leading-relaxed space-y-4" data-id="element-48">
          {content}
        </div>
      </div>
    </div>;
}
const privacyContent = <>
    <p data-id="element-49">
      <strong className="text-white" data-id="element-50">Última actualización:</strong> Marzo 2026
    </p>
    <p data-id="element-51">
      En CDL El Atajo, respetamos tu privacidad y nos comprometemos a proteger
      tu información personal. Esta política describe cómo recopilamos, usamos y
      protegemos tus datos.
    </p>
    <h4 className="text-white font-oswald text-lg uppercase mt-4" data-id="element-52">
      Información que Recopilamos
    </h4>
    <p data-id="element-53">
      Recopilamos información que nos proporcionas directamente al realizar una
      compra, incluyendo tu nombre, dirección de correo electrónico e
      información de pago. La información de pago es procesada de forma segura
      por nuestro proveedor de pagos y no almacenamos datos de tarjetas de
      crédito en nuestros servidores.
    </p>
    <h4 className="text-white font-oswald text-lg uppercase mt-4" data-id="element-54">
      Uso de la Información
    </h4>
    <p data-id="element-55">
      Utilizamos tu información para: procesar tu compra y entregar el producto
      digital, enviarte confirmaciones de pedido y actualizaciones del producto,
      y mejorar nuestros servicios y experiencia del usuario.
    </p>
    <h4 className="text-white font-oswald text-lg uppercase mt-4" data-id="element-56">
      Protección de Datos
    </h4>
    <p data-id="element-57">
      Implementamos medidas de seguridad técnicas y organizativas para proteger
      tu información personal contra acceso no autorizado, pérdida o alteración.
      Todas las transacciones se realizan a través de conexiones encriptadas
      (SSL/TLS).
    </p>
    <h4 className="text-white font-oswald text-lg uppercase mt-4" data-id="element-58">Cookies</h4>
    <p data-id="element-59">
      Nuestro sitio web puede utilizar cookies para mejorar tu experiencia de
      navegación y analizar el tráfico del sitio. Puedes configurar tu navegador
      para rechazar cookies, aunque esto puede afectar algunas funcionalidades.
    </p>
    <h4 className="text-white font-oswald text-lg uppercase mt-4" data-id="element-60">
      Tus Derechos
    </h4>
    <p data-id="element-61">
      Tienes derecho a acceder, corregir o eliminar tu información personal en
      cualquier momento. También puedes solicitar una copia de los datos que
      tenemos sobre ti.
    </p>
    <h4 className="text-white font-oswald text-lg uppercase mt-4" data-id="element-62">
      Cambios a Esta Política
    </h4>
    <p data-id="element-63">
      Nos reservamos el derecho de actualizar esta política de privacidad en
      cualquier momento. Los cambios serán publicados en esta página con la
      fecha de actualización correspondiente.
    </p>
  </>;
const termsContent = <>
    <p data-id="element-64">
      <strong className="text-white" data-id="element-65">Última actualización:</strong> Marzo 2026
    </p>
    <p data-id="element-66">
      Al acceder y utilizar los productos y servicios de CDL El Atajo, aceptas
      estos términos y condiciones en su totalidad. Si no estás de acuerdo con
      alguno de estos términos, no utilices nuestros servicios.
    </p>
    <h4 className="text-white font-oswald text-lg uppercase mt-4" data-id="element-67">
      Producto Digital
    </h4>
    <p data-id="element-68">
      CDL El Atajo es una guía de estudio digital en formato PDF diseñada para
      ayudar en la preparación del examen teórico CDL Clase A. El producto se
      entrega de forma electrónica inmediatamente después de la compra.
    </p>
    <h4 className="text-white font-oswald text-lg uppercase mt-4" data-id="element-69">
      Uso Permitido
    </h4>
    <p data-id="element-70">
      La licencia de uso es personal e intransferible. No está permitido copiar,
      distribuir, revender o compartir el contenido del producto con terceros.
      El uso es exclusivamente para estudio personal del comprador.
    </p>
    <h4 className="text-white font-oswald text-lg uppercase mt-4" data-id="element-71">
      Descargo de Responsabilidad
    </h4>
    <p data-id="element-72">
      CDL El Atajo es una herramienta de estudio complementaria y no garantiza
      la aprobación del examen del DMV. Los resultados dependen del esfuerzo
      individual de cada usuario. Este producto no está afiliado, respaldado ni
      patrocinado por ningún Departamento de Vehículos Motorizados (DMV)
      gubernamental.
    </p>
    <h4 className="text-white font-oswald text-lg uppercase mt-4" data-id="element-73">
      Política de Reembolso
    </h4>
    <p data-id="element-74">
      Debido a la naturaleza digital del producto y su entrega inmediata, todas
      las ventas son finales. No se ofrecen reembolsos una vez que el producto
      ha sido descargado o el acceso ha sido otorgado.
    </p>
    <h4 className="text-white font-oswald text-lg uppercase mt-4" data-id="element-75">
      Propiedad Intelectual
    </h4>
    <p data-id="element-76">
      Todo el contenido, incluyendo textos, gráficos, métodos y sistemas de
      estudio contenidos en CDL El Atajo son propiedad exclusiva de sus
      creadores y están protegidos por las leyes de propiedad intelectual.
    </p>
    <h4 className="text-white font-oswald text-lg uppercase mt-4" data-id="element-77">
      Modificaciones
    </h4>
    <p data-id="element-78">
      Nos reservamos el derecho de modificar estos términos en cualquier
      momento. El uso continuado del producto después de cualquier cambio
      constituye la aceptación de los nuevos términos.
    </p>
  </>;
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [modal, setModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-slate-950 py-12 px-4 sm:px-6 lg:px-8 border-t border-slate-800" data-id="element-79">
        <div className="max-w-6xl mx-auto text-center" data-id="element-80">
          <h2 className="text-2xl font-oswald font-bold text-slate-500 mb-6 uppercase tracking-widest" data-id="element-81">
            CDL CLASS A: EL ATAJO
          </h2>

          <p className="text-slate-600 text-sm max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-82">
            Descargo de responsabilidad: Este producto es una guía de estudio
            independiente y no está afiliado, respaldado ni patrocinado por
            ningún Departamento de Vehículos Motorizados (DMV) gubernamental.
            Los resultados pueden variar según el esfuerzo individual.
          </p>

          <div className="flex items-center justify-center gap-6 mb-8" data-id="element-83">
            <button onClick={() => setModal('privacy')} className="text-slate-500 hover:text-amber-500 text-sm font-medium transition-colors underline underline-offset-4 decoration-slate-700 hover:decoration-amber-500" data-id="element-84">
              Política de Privacidad
            </button>
            <span className="text-slate-700" data-id="element-85">|</span>
            <button onClick={() => setModal('terms')} className="text-slate-500 hover:text-amber-500 text-sm font-medium transition-colors underline underline-offset-4 decoration-slate-700 hover:decoration-amber-500" data-id="element-86">
              Términos y Condiciones
            </button>
          </div>

          <div className="text-slate-700 text-sm" data-id="element-87">
            &copy; {currentYear} CDL El Atajo. Todos los derechos reservados.
          </div>
        </div>
      </footer>

      {modal === 'privacy' && <LegalModal title="Política de Privacidad" content={privacyContent} onClose={() => setModal(null)} data-id="element-88" />}
      {modal === 'terms' && <LegalModal title="Términos y Condiciones" content={termsContent} onClose={() => setModal(null)} data-id="element-89" />}
    </>;
}